/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate")

package js.features.publicDepositGiftCard

import kangaroorewards.appsdk.core.api.Api
import kangaroorewards.appsdk.core.domain.SerializedResult
import kangaroorewards.appsdk.core.domain.toJsonResult
import kotlinx.coroutines.DelicateCoroutinesApi
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.promise
import kotlin.js.Promise
import kotlinx.serialization.json.Json
import features.publicDepositGiftCard.PublicDepositGiftCardApi
import features.publicDepositGiftCard.models.TransferActionResultModel
import features.publicDepositGiftCard.serializePublicDepositGiftCardState



/**
 * Deposit a gift card using public API [Api] class
 */
@OptIn(DelicateCoroutinesApi::class)
@ExperimentalJsExport
@JsExport
@JsName("PublicDepositGiftCardApi")
class PublicDepositGiftCardApiJs {

    /**
     * Deposit a gift card using public API
     */
    fun publicDepositGiftCard(
        overrideHeaders: String?, 
        userId: String,
        messageId: String
    ): Promise<String?>  {
        return GlobalScope.promise {

        val decodedOverrideHeaders = if (overrideHeaders == null) {
                null
        } else {
            try {
                Json.decodeFromString<Map<String, String>>(overrideHeaders)
            } catch (e: Exception) {
                null
                }
            }

            val result = PublicDepositGiftCardApi().publicDepositGiftCard(
            overrideHeaders = decodedOverrideHeaders,
                        userId = userId,
            messageId = messageId
        ).toJsonResult<TransferActionResultModel>()
        
            return@promise when (result) {
                is SerializedResult.Success -> result.data
                is SerializedResult.UnauthorizedError -> result.error
                is SerializedResult.UnknownError -> result.error
                else -> null
            }
        }
    }

    

    

    fun observePublicDepositGiftCardState(
        onData: (String) -> Unit,
        onStreamError: (String) -> Unit,
    ) {
        PublicDepositGiftCardApi().publicDepositGiftCardState.serializePublicDepositGiftCardState().observe { result ->
            when (result) {
                is SerializedResult.Idle -> onData(result.state)
                is SerializedResult.Loading -> onData(result.state)
                is SerializedResult.Success -> onData(result.data)
                is SerializedResult.UnauthorizedError -> onData(result.error)
                is SerializedResult.UnknownError -> onData(result.error)
                else -> onStreamError("unknown error in stream")
            }
        }
    }
}
